export default {
  sections: {
    asap_orders: {
      title: 'Zamówienia natychmiastowe',
      fields: {
        has_live_orders: {
          label: 'Zamówienia na żywo',
          tooltip:
            'Włącz ten przełącznik tylko wtedy, gdy restauracja faktycznie uruchamia się i zaczyna przyjmować zamówienia',
        },
        has_asap_orders: {
          label: 'Czy klienci mogą składać zamówienia natychmiastowe (ASAP)?',
          tooltip: '*Zamówienia ASAP są oparte na czasie przygotowania',
        },
      },
    },
    scheduled_orders: {
      title: 'Zamówienia zaplanowane',
      fields: {
        has_scheduled_orders: {
          label: 'Czy klienci mogą zamawiać z wyprzedzeniem na określone godziny?',
        },
        has_pre_order: {
          label: 'Czy klienci mogą zamawiać z wyprzedzeniem o więcej niż jeden dzień?',
        },
        max_pre_order_days: {
          label: 'Maksymalna liczba dni zamówienia z wyprzedzeniem',
          placeholder: '14',
        },
        has_scheduled_order_reminders: {
          label: 'Powiadomienia o zaplanowanych zamówieniach',
        },
        scheduled_orders_time_slot_interval: {
          label: 'Przedziały czasowe w minutach',
          option: 'Przedział {{value}} minut',
        },
        has_scheduled_orders_time_slot_order_limit: {
          label: 'Dodaj maksymalną liczbę zamówień na przedział czasowy',
        },
        scheduled_orders_time_slot_order_limit: {
          label: 'Maksymalna liczba zamówień na przedział czasowy',
          placeholder: '5',
        },
        order_instructions_title: {
          label: 'Instrukcje zamówienia',
          placeholder: 'Wprowadź instrukcje zamówienia',
        },
        scheduled_order_option_title: {
          label: 'Tytuł opcji zaplanowania na później',
          placeholder: 'Zaplanuj na później',
        },
      },
    },
    other: {
      title: 'Inne',
      fields: {
        order_approval_time_step: {
          label: 'Dodawanie / skracanie potwierdzonego czasu zamówienia',
          option: '{{value}} min',
        },
        order_confirmation_time_extra_minutes: {
          label: 'Dodawanie dodatkowych minut do potwierdzonego czasu',
          option: '{{value}} min',
        },
      },
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  feedback: {
    restaurant_suspended: {
      title: 'Ta restauracja została zawieszona',
      description:
        'Aby móc wrócić do działania, przejdź do <a>strony subskrypcji</a> i reaktywuj restaurację, a następnie będziesz mógł włączyć zamówienia na żywo na tej stronie.',
    },
  },
  toasts: {
    at_least_one_order_method_required:
      'Co najmniej 1 metoda zamówienia (zaplanowane lub natychmiast) musi być włączona. Nie można wyłączyć obu.',
  },
};
